var _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _line17, _line18, _line19;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBox(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1135,
    height: 347,
    viewBox: "0 0 1135 347",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 44,
    y1: 2,
    x2: 437,
    y2: 2.00003,
    stroke: "#2A2A2A",
    strokeWidth: 4
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 44,
    y1: 344,
    x2: 352,
    y2: 344,
    stroke: "#2A2A2A",
    strokeWidth: 4
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 391.994,
    y1: 321,
    x2: 741.994,
    y2: 320,
    stroke: "#2A2A2A",
    strokeWidth: 4
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 782,
    y1: 344,
    x2: 1090,
    y2: 344,
    stroke: "#2A2A2A",
    strokeWidth: 4
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    y1: -2,
    x2: 393,
    y2: -2,
    transform: "matrix(-1 8.74228e-08 8.74228e-08 1 1092 4)",
    stroke: "#2A2A2A",
    strokeWidth: 4
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 27,
    x2: 3,
    y2: 132,
    stroke: "#2A2A2A",
    strokeWidth: 6
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: 185,
    x2: 5.00001,
    y2: 321,
    stroke: "#2A2A2A",
    strokeWidth: 6
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 1131,
    y1: 27,
    x2: 1131,
    y2: 134,
    stroke: "#2A2A2A",
    strokeWidth: 6
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 1131,
    y1: 189,
    x2: 1131,
    y2: 320,
    stroke: "#2A2A2A",
    strokeWidth: 6
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 1084,
    y1: 178,
    x2: 1084,
    y2: 301,
    stroke: "#2A2A2A",
    strokeWidth: 4
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    y1: -2,
    x2: 123,
    y2: -2,
    transform: "matrix(-4.37114e-08 1 1 4.37114e-08 54 178)",
    stroke: "#2A2A2A",
    strokeWidth: 4
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 1133,
    y1: 150.73,
    x2: 1083,
    y2: 179.705,
    stroke: "#2A2A2A",
    strokeWidth: 4
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    y1: -2,
    x2: 57.7884,
    y2: -2,
    transform: "matrix(0.865225 0.501383 0.501383 -0.865225 4 149)",
    stroke: "#2A2A2A",
    strokeWidth: 4
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    x1: 45.1,
    y1: 1.67034,
    x2: 4.09998,
    y2: 28.6703,
    stroke: "#2A2A2A",
    strokeWidth: 4
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    x1: 45.9652,
    y1: 344.711,
    x2: 2.96516,
    y2: 318.711,
    stroke: "#2A2A2A",
    strokeWidth: 4
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    y1: -2,
    x2: 51.4293,
    y2: -2,
    transform: "matrix(0.86035 -0.509704 -0.509704 -0.86035 1088 343.214)",
    stroke: "#2A2A2A",
    strokeWidth: 4
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    x1: 350.998,
    y1: 344.538,
    x2: 392.898,
    y2: 320.269,
    stroke: "#2A2A2A",
    strokeWidth: 4
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    y1: -2,
    x2: 48.4211,
    y2: -2,
    transform: "matrix(-0.867121 -0.498097 -0.498097 0.867121 781.773 345.483)",
    stroke: "#2A2A2A",
    strokeWidth: 4
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    y1: -2,
    x2: 49.0918,
    y2: -2,
    transform: "matrix(0.835171 0.549991 0.549991 -0.835171 1092 0)",
    stroke: "#2A2A2A",
    strokeWidth: 4
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBox);
export default __webpack_public_path__ + "static/media/box.91ea747efc31d4e26729d68140bacfff.svg";
export { ForwardRef as ReactComponent };